import { getCropList } from 'crops/selectors';
import { parseCropList } from 'crops/seedAdvisorParser';
import { processCropList } from 'crops/processors';
import { resourceType } from 'constants/loading';
import { SUPPORTED_CROPS } from 'constants/crops';
import { fetchCropList } from 'crops/loaders';
import { findResource } from 'loading/finders';
import { parseOLCropList } from 'crops/sproutParser';

export const findCropList = ({ dispatch, getState, forceReload=false, forceWait=false, onError }) => {
  const state = getState();
  const getCropFromOL = state?.launchDarkly?.scriptCreatorConsumeCropsFromOl;

  const resourceSpec = {
    type: resourceType.CROP_LIST,
    selector: () => getCropList(getState()),
    fetcher: async () => {
      if(getCropFromOL) {
        const countryCode = state.user.accountCountry;
        const cropList = await fetchCropList(countryCode);
        return cropList.crops.nodes.length ? cropList : (await fetchCropList());
      }
      return ({ data: SUPPORTED_CROPS });
    },
    processor: ( raw ) => processCropList({ 
      dispatch,
      getState,
      cropList: getCropFromOL 
        ? parseOLCropList(raw) 
        : parseCropList(raw) 
    })
  };

  return findResource({ dispatch, getState, forceReload, forceWait, onError, ...resourceSpec });
};
